/***
 *
 *   ASSIGNEE AVATARS
 *   Overlapping avatars with a +N overflow. Ported from
 *   ui-reference/src/components/tickets/assignee-avatars.tsx.
 *
 *   PROPS
 *   assignees: array of { id?, user_id?, first_name, last_name, avatar? }
 *   max: how many faces to show before +N (default 2 on cards, 3 on list)
 *
 **********/

import { UserAvatar, Tooltip, cn, initialsFromName } from 'components/lib';

function assigneeKey(a, index) {
    return a.id || a.user_id || a.email || `${a.first_name}-${a.last_name}-${index}`;
}

function assigneeName(a) {
    return [a.first_name, a.last_name].filter(Boolean).join(' ').trim() || a.email || '';
}

export function AssigneeAvatars(props) {
    const { assignees = [], max = 3, className } = props;
    if (!assignees.length) return null;

    const visible = assignees.slice(0, max);
    const overflow = assignees.length - max;

    return (
        <div className={cn('flex items-center -space-x-2', className)}>
            {visible.map((a, index) => {
                const name = assigneeName(a);
                return (
                    <Tooltip key={assigneeKey(a, index)} label={name} delayDuration={300}>
                        <UserAvatar
                            name={name}
                            initials={initialsFromName(name)}
                            src={a.avatar || a.avatar_url}
                            size="sm"
                            className="border-2 border-surface"
                        />
                    </Tooltip>
                );
            })}
            {overflow > 0 && (
                <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-surface bg-muted text-xs font-semibold text-text-secondary">
                    +{overflow}
                </div>
            )}
        </div>
    );
}
